import type { IconLine } from '@/scopes/prices/infrastructure/transport/types'
import type { IconGlyph } from '@sunwebgroup/ui-components'

const ICONS_MAP: Record<string, IconGlyph> = {
  'icon-building': 'IconBuilding',
  'icon-calendar': 'IconCalendar',
  'icon-family': 'IconFamily',
  'icon-flight-outbound': 'IconAirplaneDeparture',
  'icon-flight-inbound': 'IconAirplaneReturn',
}

export function mapTripSummary(item: IconLine) {
  const icon = ICONS_MAP[item.icon]
  const headerText = item.lines.find(line => line.isBold)?.text || ''
  const stars = item.lines.find(line => line.isBold)?.metadata?.split(':')[1]
  const extraInfo = item.lines.filter(line => !line.isBold).map(line => line.text)

  return {
    header: {
      icon,
      text: headerText,
      stars: stars ? Number.parseInt(stars) : undefined,
    },
    extraInfo,
  }
}
